import { Field } from './field.model';
import { SchemaProperty } from './schema-property.model';
import { SchemaScript } from './schema-script.model';
import { Link } from './link.model';

export class Schema {
  created: Date;
  createdBy: string;
  category: string;
  fields: Field[];
  id: string;
  isPublished: boolean;
  isSingleton: boolean;
  lastModified: Date;
  lastModifiedBy: string;
  name: string;
  previousUrls: { [id: string]: string };
  properties: SchemaProperty;
  scripts: SchemaScript;
  version: number;
  _links: { [id: string]: Link };

  constructor(current?: any) {
    if (current) {
      Object.assign(this, current);
    } else {
      this.properties = new SchemaProperty();
      this.scripts = new SchemaScript();
    }
  }

}
